export default {
  labels: {
    custom: 'Personalizado - Disponível mediante pedido',
    was: 'Era {{amount}} – desconto anual aplicado',
  },
  tags: {
    preferred: 'Especialmente popular',
    net_one_time: 'líquido, pagamento único',
    annual_discount: '-{{percentage}}% anual',
  },
  buttons: {
    select_plan: 'Escolher este plano',
  },
};
